export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'saaspos_access_token',
  REFRESH_TOKEN: 'saaspos_refresh_token',
  SELECTED_STORE: 'saaspos_selected_store',
  THEME: 'saaspos_theme',
  ENABLED_FEATURES: 'fattah_enabled_features',
  ONBOARDING_STATE: 'erp_onboarding_state',
  ONBOARDING_DONE: 'erp_onboarding_done',
  ONBOARDING_PRODUCTS_DONE: 'erp_onboarding_products_done',
  /** 'fattah-one' = multi-product picker; absent after module-direct signup */
  ONBOARDING_FLOW: 'erp_onboarding_flow',
  ENTRY_MODULE: 'saaspos_entry_module',
  PENDING_ENTRY_MODULE: 'saaspos_pending_entry_module',
  /** Active UI workspace (POS, CRM, …) — especially for org owners with unscoped JWT. */
  WORKSPACE_MODULE: 'saaspos_workspace_module',
} as const;
